const map = {
	"./jungle_blue.png": 87021,
	"./jungle_blue_dark.png": 22526,
	"./jungle_grayscale.png": 79340,
	"./jungle_grayscale_dark.png": 26013,
	"./jungle_green.png": 25396,
	"./jungle_green_dark.png": 98965,
	"./jungle_light.png": 65273,
	"./jungle_purple.png": 39819,
	"./jungle_purple_dark.png": 3468,
	"./jungle_red.png": 60752,
	"./jungle_red_dark.png": 39705,
	"./jungle_yellow.png": 3501,
	"./jungle_yellow_dark.png": 57694
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 86673;